import Assignments from '@/views/assignments/Assignments'

export default [
  {
    path: 'asignaciones',
    name: 'assignments.list',
    component: Assignments
  }
]
